import React from "react";
import CityList from "./CityList";
import { Subscribe } from "unstated";
import SrpContainer from "../containers/SrpContainer";
import NoSrpContact from "./NoSrpContact";

const PlaceNotFound = ({ cities }) => (
  <div className="ux-not-found-page">
    <div className="ux-circle-large" />

    <p className="no-srp-head-title">
      We could not detect the location to search
    </p>

    <NoSrpContact />

    <CityList cities={cities} />
  </div>
);

PlaceNotFound.propTypes = {
  ...CityList.propTypes,
};

const PlaceNotFoundContainer = () => (
  <Subscribe to={[SrpContainer]}>
    {({ state: { data } }) => <PlaceNotFound cities={data.cities} />}
  </Subscribe>
);

export default PlaceNotFoundContainer;
